export const homObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'About Me',
    headline: 'Here\'s a bit about me',
    description: 'Currently, I am pursuing my MS in Software Engineering degree from Arizona State University, AZ, USA.<br/> I\'m passionate about coding, and trying out new things is my favourite passtime. Click the button below to get to know me better!',
    buttonLabel: 'Download Resume',
    imgStart: false,
    img: require('../../images/svg-portfolio.svg').default,
    alt: 'Car',
    dark: true,
    primary: true,
    darkText: false,
    multiple: false,
    to: 'socials'
};

export const homObjTwo = {
    id: 'expertise',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'My Expertise',
    headline: 'A few technologies I <3',
    description: 'C++ | ReactJS | JavaScript | MongoDB | HTML/CSS | GraphQL | NodeJS | Ruby on Rails | AWS | C# | .NET<br/> Firebase',
    buttonLabel: 'My projects',
    imgStart: true,
    img: require('../../images/svg-coding.svg').default,
    alt: 'Car',
    dark: false,
    primary: false,
    darkText: true,
    multiple: false,
    to: 'projects'
};

export const homObjThree = {
    id: 'socials',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Contact me',
    headline: 'Socials',
    description: 'Contact me on any one of my social accounts, or take a look at my resume',
    buttonLabel: 'Github',
    imgStart: false,
    img: require('../../images/svg-contact.svg').default,
    alt: 'Car',
    dark: false,
    primary: false,
    darkText: true,
    multiple: true
};



